import apiClient from '../client';
import $U from '../urls';

export const fetchBasket = () => {
  return apiClient.request('GET', $U.BASKET);
};

export const addProduct = (pk, quantity = 1, attributes = {}) => {
  const data = { product: pk, quantity, ...attributes };
  return apiClient.request('POST', $U.BASKET, data);
};

export const setQuantity = (pk, quantity, attributes = {}) => {
  const data = { product: pk, quantity, ...attributes };
  return apiClient.request('PUT', $U.BASKET, JSON.stringify(data),
    {
      dataType: 'json',
      contentType: 'application/json'
    });
};

export const removeProduct = (pk, attributes = {}) => {
  const data = { product: pk, quantity: 0, ...attributes };
  return apiClient.request('PUT', $U.BASKET, JSON.stringify(data),
    {
      dataType: 'json',
      contentType: 'application/json'
    });
};

export const setDiscount = (code, paramName='voucher_code') => {
  const data = { [paramName]: code };
  return apiClient.request('PATCH', $U.BASKET, data);
};

export const removeDiscount = () => {
  const data = { remove_voucher_code: true };
  return apiClient.request('PATCH', $U.BASKET, data);
};

export const setGiftNote = (basketItemId, giftNote) => {
  const data = {
    attributes: {
      gift_note: giftNote,
    },
    id: basketItemId,
    is_all: true,
  };
  return apiClient.request('PATCH', $U.BASKET_ITEMS, JSON.stringify(data),
    {
      dataType: 'json',
      contentType: 'application/json'
    });
};
